/**
 * Uses Swiper package to create a carousel for product media
 * More info: https://swiperjs.com/
 */
class ProductMedia extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.initElements();
    this.initSlider();
    this.attachEvents();
  }

  attachEvents() {
    this.debouncedOnResize = debounce(() => {
      const isMobileDevices = window.matchMedia(
        this.mobileBreakpoint,
      ).matches;

      if (isMobileDevices && !this.slider) {
        this.initSlider();
      } else if (this.slider) {
        this.destroySlider();
      }
    }, 100);

    window.addEventListener('resize', this.debouncedOnResize.bind(this));
  }

  initElements() {
    this.mobileBreakpoint = '(max-width: 767px)';
    this.slider = null;
    this.options = {
      slidesPerView: 1,
      spaceBetween: 0,
      pagination: {
        el: this.querySelector('.swiper-pagination'),
        type: 'fraction',
      },
    };
  }

  initSlider() {
    const isMobileDevices = window.matchMedia(this.mobileBreakpoint).matches;

    if (!this.querySelector('[data-slider]') || this.slider !== null || !isMobileDevices) return;

    this.slider = new Swiper(
      this.querySelector('[data-slider]'),
      this.options,
    );
  }

  destroySlider() {
    this.slider.destroy();

    this.slider = null;
  }
}

customElements.define('product-media', ProductMedia);
